import { createI18n } from "vue-i18n";
// import messages from "@intlify/vite-plugin-vue-i18n/messages";

// 自定义国际化文件
import zhTW from "./zh-TW.json";
import en from "./en-US.json";
import jaJP from "./ja-JP.json";

const i18n = createI18n({
  legacy: false, // Composition API 模式
  globalInjection: true, // 全局注册 $t方法 // 默认语言
  locale: "en-US", // 语言库
  warnHtmlInMessage: "off",
  silentTranslationWarn: true,
  missingWarn: false,
  silentFallbackWarn: true,
  fallbackWarn: false,
  messages: {
    "ja-JP": jaJP,
    "zh-TW": zhTW,
    "en-US": en,
  },
});

// 将i18n暴露出去，在main.js中引入挂载
export default i18n;
